import axios from "axios";
import Config from "../../../config";

const v2_actionLeaveGroup = (chatId) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/leave`
});

export default v2_actionLeaveGroup;
